export const fetchCdnJson = async (url: string) => {
  const response = await fetch(url, {
    cache: "no-cache",
    credentials: "omit",
    mode: "cors",
  });

  if (!response.ok) {
    throw Object.assign(
      new Error(`Failed to fetch CDN JSON: ${response.status} ${response.statusText}`),
      { response: { status: response.status } }
    );
  }

  return response.json();
};
